import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { SelectorData } from 'src/app/utils/selectorDataType';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/**
 *Radio Component
 */
export class RadioComponent {
  @Input() options!: SelectorData[];
  @Output() emitOption = new EventEmitter<any>();
  @Input() isVertical? = false;
  @Input() disabled: boolean = false;

  @Input() selectedOption!: string;

  /**
   *
   * @param {string} value
   */
  onSelectionChange(value: string): void {
    this.selectedOption = value;
    this.emitOption.emit(this.selectedOption);
  }
}
